import { Expose } from 'class-transformer'

export class SupplyChain {
  static type = 'supplychain'

  type = SupplyChain.type

  @Expose({ name: 'xid' })
  guid: string = ''

  nam?: string = ''
}
